import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { getAllNews } from '../../api/news/getAllNews';

export const useGetAllNews = (params?: Record<string, string | number>) => {
  const [page, setPage] = useState(1);

  const { data, isSuccess, isLoading, refetch } = useQuery({
    queryKey: ['getAllNews', page],
    queryFn: () => getAllNews({ page, ...params }),
  });

  return {
    allNewsData: data,
    isGetAllNewsSuccess: isSuccess,
    isGetAllNewsLoading: isLoading,
    allNewsRefetch: refetch,
    setPage,
    page,
  };
};
